interface FlagEmojiProps {
  countryCode: string;
  className?: string;
}

export const FlagEmoji = ({ countryCode, className = "" }: FlagEmojiProps) => {
  // Convert ISO country code to flag emoji
  const getFlagEmoji = (countryCode: string): string => {
    // Normalize code to uppercase for consistent matching
    const code = countryCode?.trim().toUpperCase();

    // Handle special cases
    const specialCases: Record<string, string> = {
      AS: "🇦🇸", // American Samoa
      AQ: "🇦🇶", // Antarctica
      BL: "🇧🇱", // Saint Barthélemy
      IO: "🇮🇴", // British Indian Ocean Territory
      VG: "🇻🇬", // British Virgin Islands
      CX: "🇨🇽", // Christmas Island
      CC: "🇨🇨", // Cocos Islands
      CW: "🇨🇼", // Curaçao
      FK: "🇫🇰", // Falkland Islands
      FO: "🇫🇴", // Faroe Islands
      PF: "🇵🇫", // French Polynesia
      GG: "🇬🇬", // Guernsey
      GU: "🇬🇺", // Guam
      HK: "🇭🇰", // Hong Kong
      IM: "🇮🇲", // Isle of Man
      JE: "🇯🇪", // Jersey
      KY: "🇰🇾", // Cayman Islands
      MF: "🇲🇫", // Saint Martin
      MO: "🇲🇴", // Macao
      MP: "🇲🇵", // Northern Mariana Islands
      MS: "🇲🇸", // Montserrat
      NC: "🇳🇨", // New Caledonia
      NU: "🇳🇺", // Niue
      PN: "🇵🇳", // Pitcairn
      PM: "🇵🇲", // Saint Pierre and Miquelon
      PR: "🇵🇷", // Puerto Rico
      RE: "🇷🇪", // Réunion
      SH: "🇸🇭", // Saint Helena
      SJ: "🇸🇯", // Svalbard and Jan Mayen
      SX: "🇸🇽", // Sint Maarten
      TC: "🇹🇨", // Turks and Caicos Islands
      TK: "🇹🇰", // Tokelau
      VI: "🇻🇮", // U.S. Virgin Islands
      WF: "🇼🇫", // Wallis and Futuna
      YT: "🇾🇹", // Mayotte
      XK: "🇽🇰", // Kosovo
    };

    if (specialCases[code]) {
      return specialCases[code];
    }

    // Convert standard ISO codes to flag emojis
    if (code && code.length === 2) {
      const codePoints = code
        .split("")
        .map((char) => 127397 + char.charCodeAt(0));

      return String.fromCodePoint(...codePoints);
    }

    // Fallback for unknown codes
    return "🏳️";
  };

  return (
    <span
      className={`inline-block ${className}`}
      role="img"
      aria-label={`${countryCode} flag`}
    >
      {getFlagEmoji(countryCode)}
    </span>
  );
};
